/**
 * Who else is on this board (spec M0-F5 §8, C1).
 *
 * Up to five avatars and a `+N`, **ordered by join time** — the server sorts the roster, so
 * the strip does not reorder under people as they type — each with monday's own tooltip
 * wording, "<name> is viewing this board". A viewer with a cell editor open says so instead.
 *
 * `partial` means there is no Redis and this is one api process's view of the board. The
 * strip then says "at least", because claiming a count we cannot know is worse than
 * admitting the limit (§4.3).
 */
import { PersonAvatar } from '../columns/primitives';
import { useTable } from './context';
import './table.css';

/** monday shows five and counts the rest. */
const VISIBLE = 5;

export function PresenceStrip() {
  const presence = useTable((state) => state.presence);
  if (!presence || presence.users.length === 0) return null;

  const shown = presence.users.slice(0, VISIBLE);
  const overflow = presence.total - shown.length;

  return (
    <div
      className="ez-presence"
      data-testid="presence-strip"
      data-partial={presence.partial || undefined}
      aria-label={
        presence.partial
          ? `At least ${String(presence.total)} people are viewing this board`
          : `${String(presence.total)} people are viewing this board`
      }
    >
      {shown.map((user) => (
        <span
          key={user.userId}
          className="ez-presence__avatar"
          data-testid={`presence-${user.userId}`}
          data-editing={user.editing ? '' : undefined}
          title={
            user.editing
              ? `${user.name} is editing a cell`
              : `${user.name} is viewing this board`
          }
        >
          <PersonAvatar name={user.name} color={user.color} photoUrl={user.photoUrl} size={24} />
        </span>
      ))}
      {overflow > 0 ? (
        <span className="ez-presence__more" data-testid="presence-more">
          {`+${String(overflow)}`}
        </span>
      ) : null}
    </div>
  );
}
